// axios
import axios from 'axios'

const baseURL = process.env.VUE_APP_BACKEND_URL
//const baseURL = "http://localhost:4000"

export default axios.create({
  baseURL: baseURL
  // You can add your headers here
})
